<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/11/2021
  -->

<template>
	<el-radio-group v-bind="listenersComputed" class="qw-radio-group-root"><slot></slot></el-radio-group>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "QwRadioGroup",
	extends: BaseComponent,
	inheritAttrs: false,


	watch: {
		"$attrs.modelValue"(newValue, oldValue) {
			this.prevValue = oldValue
			console.log("QwRadioGroup: $attrs.value changed: ", ...arguments)
		}
	},

	data() {
		return {
			prevValue: null
		}
	},
	methods: {
		name() {

		}
	},

	computed: {
		listenersComputed() {
			let changeLocal = this.$attrs.onChange || (() => {})
			let {onChange,  ...rest} = this.$attrs
			return {
				...rest,
				onChange: (value) => changeLocal(value, this.prevValue)
			}
		}
	},

}
</script>

<style lang="scss">
.qw-radio-group-root{
	&.el-radio-group{
		line-height: inherit;
	}
}
</style>
